import { render, staticRenderFns } from "./tab-head.vue?vue&type=template&id=1caa093e&scoped=true&"
import script from "./tab-head.vue?vue&type=script&lang=js&"
export * from "./tab-head.vue?vue&type=script&lang=js&"
import style0 from "./tab-head.vue?vue&type=style&index=0&id=1caa093e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa093e",
  null
  
)

export default component.exports